// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"302":"db705e21","453":"4edb15ee","582":"a29f88eb"}[chunkId] + ".chunk.js";
};